const menuItems = [
    {
      title: "Home",
      url: "/",
      cName: "nav-links"
    },
    {
      title: "Travel & adventure",
      url: "/travel",
      cName: "nav-links"
    },
    {
      title: "Health & wellness",
      url: "/health",
      cName: "nav-links"
    },
    {
      title: "Food & recipes",
      url: "/food",
      cName: "nav-links"
    },
    {
        title: "All",
        url: "/all",
        cName: "nav-links"
      },
      {
        title: "About",
        url: "about",
        cName: "nav-links"
      },
      {
        title: "Contact",
        url: "/contact",
        cName: "nav-links"
      },
      {
        title: "Login",
        url: "/admin",
        cName: "nav-links"
      }
  ];
  
  export default menuItems;